<template>
  <div class="pagination-container">
    <button type="button" class="btn" @click="prevPage" :disabled="page.pageIndex == 1"><i class="el-icon el-icon-arrow-left"></i></button>
    <ul>
      <li @click="setPageIndex(item)" :class="item === page.pageIndex?'selected':''" v-for="item in page.pageList" :key="item">{{item}}</li>
    </ul>
    <button type="button" class="btn" @click="nextPage" :disabled="page.endIndex == 0 || (page.pageIndex == page.endIndex  && page.haveMoreData)"><i class="el-icon el-icon-arrow-right"></i></button>
  </div>
</template>

<script>
import Pagination from '@common/utils/page.js'
export default {
  props: {
    pageTotal: {
      type: Number,
      default: 10
    },
    pageSize: {
      type: Number,
      default: 10
    },
    loadDataFunc: Function || null,
  },
  data () {
    return {
      page: {
        endIndex: 0
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      let vm = this
      let page = new Pagination(vm.pageSize, vm.pageTotal, vm.loadDataFunc)
      vm.page = page
    },
    nextPage () {
      let vm = this
      vm.page.nextPage()
      vm.$emit("change", vm.page.data)
    },
    prevPage () {
      let vm = this
      this.page.prevPage()
      vm.$emit("change", vm.page.data)
    },
    setPageIndex (index) {
      this.page.setPageIndex(index)
      this.$emit("change", this.page.data)
    },
    /**
     * 
     */
    setPageData (data) {
      let vm = this
      vm.page.setDataSource(data)
      vm.$emit("change", vm.page.data)
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination-container {
  white-space: nowrap;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
  .btn {
    margin: 0 5px;
    background-color: #f4f4f5;
    color: #606266;
    min-width: 30px;
    border-radius: 2px;
    border: 0px;
    cursor: pointer;
    display: inline-block;
    font-size: 13px;
    height: 28px;
    line-height: 28px;
    vertical-align: top;
    box-sizing: border-box;
    &:disabled {
      cursor: not-allowed;
    }
  }
  ul {
    user-select: none;
    list-style: none;
    display: inline-block;
    vertical-align: top;
    font-size: 0;
    padding: 0;
    margin: 0;
    li {
      margin: 0 5px;
      background-color: #f4f4f5;
      color: #606266;
      min-width: 30px;
      border-radius: 2px;
      padding: 0 4px;
      vertical-align: top;
      display: inline-block;
      font-size: 13px;
      height: 28px;
      line-height: 28px;
      cursor: pointer;
      box-sizing: border-box;
      text-align: center;
    }
    li.selected,
    li:hover {
      background-color: #409eff;
      color: #fff;
    }
    li.selected {
      cursor: default;
      pointer-events: none;
    }
  }
}
</style>